import { Image } from "primereact/image";
import iconForwardGrey from "assets/icons/icon_forward_grey.svg";

export const DetailRepliedAnswer = ({
  repliedAnswer,
  className = "",
}: {
  repliedAnswer: string;
  className?: string;
}) => {
  const truncatedAnswer =
    repliedAnswer.length > 256
      ? `${repliedAnswer.substring(0, 256)}...`
      : repliedAnswer;
  return (
    <div className={`flex-container gap-8 word-break-all ${className}`}>
      <Image src={iconForwardGrey} width="16" height="16" />
      <span className="text-regular-blue-disable break-wrap-word">
        {truncatedAnswer}
      </span>
    </div>
  );
};
